/* eslint-disable import/prefer-default-export */

import { MM_DD_YYYY } from "aegion_common_utilities/lib/format/datetime";

const isDefined = v => v !== undefined && v !== null;

export const chooseJobDate = (startOrEndJob, startOrEndSurvey) => {
	const LEGACY_MV_FUZZY_LOGIC_DATE_THRESHOLD = new Date('01/01/2023'); // just for consistency, we'll use the mv fuzzy threshold.
	const jobDate = startOrEndJob;
	const surveyDate = startOrEndSurvey;
	if (!isDefined(jobDate)) {
		return surveyDate || undefined;
	}
	if (!isDefined(surveyDate)) {
		return jobDate || undefined;
	}

	if (new Date(jobDate) < LEGACY_MV_FUZZY_LOGIC_DATE_THRESHOLD || new Date(surveyDate) < LEGACY_MV_FUZZY_LOGIC_DATE_THRESHOLD) {
		return MM_DD_YYYY(new Date(Math.max(new Date(jobDate).getTime(), new Date(surveyDate).getTime())));
	}

	return jobDate;
}
